import { BitrixVue } from 'ui.vue';

BitrixVue.component('CompleteButton', {
	props: [],
	methods: {
		isShowBlock() {
			return this.$store.state.position.door && this.$store.state.position.glazingType && this.$store.state.position.doorCover && this.$store.state.position.edgeMilling;
		},
		setPositionToBasket() {
			this.$store.dispatch('setPositionBasket');
			this.$store.dispatch('setBasketChange', true);
		},
	},
	template: `
	<div class="complete-btn" @click="setPositionToBasket" v-if="isShowBlock()">Завершить комплектацию</div>
`,
});
